/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserMeResponse } from './RevisdomAPIViewModelsUserMeResponse';
import {
    RevisdomAPIViewModelsUserMeResponseFromJSON,
    RevisdomAPIViewModelsUserMeResponseFromJSONTyped,
    RevisdomAPIViewModelsUserMeResponseToJSON,
    RevisdomAPIViewModelsUserMeResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserMeResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1MeResponse
 */
export interface ApiResponse1MeResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1MeResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1MeResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserMeResponse}
     * @memberof ApiResponse1MeResponse
     */
    data?: RevisdomAPIViewModelsUserMeResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1MeResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1MeResponse interface.
 */
export function instanceOfApiResponse1MeResponse(value: object): value is ApiResponse1MeResponse {
    return true;
}

export function ApiResponse1MeResponseFromJSON(json: any): ApiResponse1MeResponse {
    return ApiResponse1MeResponseFromJSONTyped(json, false);
}

export function ApiResponse1MeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1MeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserMeResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1MeResponseToJSON(json: any): ApiResponse1MeResponse {
    return ApiResponse1MeResponseToJSONTyped(json, false);
}

export function ApiResponse1MeResponseToJSONTyped(value?: ApiResponse1MeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserMeResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

